import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div style={{ textAlign: "center",height:"100vh", backgroundColor:"#292929"}}>
           <div className="h-100 d-flex align-items-center justify-content-center flex-column">
           <h1 style={{color:"#e6be80"}}>404 - Page Not Found</h1>
            <p className="text-white">The page you are looking for does not exist.</p>
           <button style={{backgroundColor:"transparent", padding:"10px 20px", border:"1px solid #fff", }}> <Link style={{textDecoration:"none", color:"#fff"}} to="/">Go Back Home</Link></button>
           </div>
        </div>
    );
};

export default NotFound;
